import { Button, Text } from '@cubeyou-team/hx-react-components';
import React, { FC, useMemo } from 'react';
import { useSelector } from 'react-redux';

import translations from 'src/lang';
import { StyledQueryBuilderHeader } from 'src/components/QueryBuilder/StyledQueryBuilder';
import { HeaderActions } from './components';
import { QUERY_BUILDER_TYPES } from '../../constants';

interface QueryBuilderHeaderProps {
  isQueryLoading: boolean;
  isQueryValid: boolean;
  onCreateAudienceModalClose: () => void;
  onRequestCreateAudience: (app: string) => void;
}

interface QueryBuilderState {
  queryBuilderType: string;
  isCompareQuery: boolean;
  label: string;
  persistence: string;
  dataSource: string;
}

interface RootState {
  queryBuilder: QueryBuilderState;
}

export const QueryBuilderHeader: FC<QueryBuilderHeaderProps> = ({
  isQueryLoading,
  isQueryValid,
  onCreateAudienceModalClose,
  onRequestCreateAudience,
}) => {
  const queryBuilder = useSelector((state: RootState) => state.queryBuilder);

  const { queryBuilderType } = queryBuilder;

  const isConversation = useMemo(
    () => queryBuilderType === QUERY_BUILDER_TYPES.CONVERSATION,
    [queryBuilderType]
  );

  return (
    <StyledQueryBuilderHeader>
      <div className="flex items-center justify-between gap-8 p-4">
        <div className="flex items-center gap-8">
          <Button
            size="small"
            variant="outlined"
            onClick={onCreateAudienceModalClose}
          >
            Close
          </Button>
          {!isConversation && (
            <Text size="body" weight="bold">
              {translations['en-US'].QUERY_BUILDER.title.default}
            </Text>
          )}
        </div>
        <div>
          <HeaderActions
            isQueryLoading={isQueryLoading}
            isConversation={isConversation}
            isQueryValid={isQueryValid}
            onRequestCreateAudience={onRequestCreateAudience}
          />
        </div>
      </div>
    </StyledQueryBuilderHeader>
  );
};
